module.exports = __webpack_public_path__ + "img/phone.9706e852.svg";